document.addEventListener("DOMContentLoaded", function() {
  var expandButtons = document.querySelectorAll(".faq-columns .expand-button");
  var theQuestions = document.querySelectorAll(".faq-columns .the-question");
  var expandedSections = []; // Store expanded sections
  expandButtons.forEach(function(button) {
    button.addEventListener("click", function(event) {
      event.stopPropagation();
      var card = button.closest(".faq-columns .the-question");
      var expandedInfo = card.querySelector(".faq-columns .expanded-info");
      toggleAccordion(card, expandedInfo);
    });
  });
  theQuestions.forEach(function(question) {
    question.addEventListener("click", function(event) {
      var expandedInfo = question.querySelector(".faq-columns .expanded-info");
      toggleAccordion(question, expandedInfo);
    });
  });
  // Global click event listener
  document.body.addEventListener("click", function(event) {
    expandedSections.forEach(function(expandedSection) {
      if (!event.target.closest(".faq-columns .the-question") || event.target === expandedSection.button) {
        expandedSection.info.style.maxHeight = null;
        expandedSection.card.classList.remove("expanded");
        expandedSections.splice(expandedSections.indexOf(expandedSection), 1);
      }
    });
  });

  function updateIcon(card, expanded) {
  var expandButton = card.querySelector(".expand-button");
  if (expandButton) {
    if (expanded) {
      expandButton.classList.add("expanded");
      expandButton.innerHTML = `
        <svg width="15" height="14" viewBox="0 0 10 3" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.96 2.672V0.404H9.052V2.672H0.96Z" fill="black" /></svg>`;
    } else {
      expandButton.classList.remove("expanded");
      // Use your original SVG code for the collapsed state
      expandButton.innerHTML = `<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.336 13.88V8H0.568V5.928H6.336V0.216H8.464V5.928H14.232V8H8.464V13.88H6.336Z" fill="black" /></svg>`;
    }
  }
}

  function toggleAccordion(card, expandedInfo) {
  var index = expandedSections.findIndex(function(expandedSection) {
    return expandedSection.info === expandedInfo;
  });

  if (index !== -1) {
    expandedInfo.style.maxHeight = null;
    card.classList.remove("expanded");
    expandedSections.splice(index, 1);
    updateIcon(card, false); // Call the function with 'false' for collapsed state
  } else {
    expandedInfo.style.maxHeight = expandedInfo.scrollHeight + "px";
    card.classList.add("expanded");
    expandedSections.push({ card, info: expandedInfo, button: card.querySelector(".expand-button") });
    updateIcon(card, true); // Call the function with 'true' for expanded state
  }
}

});